import React, {useEffect, useState, Fragment}  from 'react'
import { Box, makeStyles, createStyles, Breadcrumbs,Typography, Button } from '@material-ui/core'
import { Link as RouterLink } from 'react-router';
import PersonIcon from '@material-ui/icons/Person';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import UpgradeModal from './UpgradeModal';
import PricingDialog1 from '../SettingsPage/PricingDialog1';
import {checkWhitelable} from '../../services/permissions'
import  ConnectionStatus  from './ConnectionStatus';
import { Elements } from 'react-stripe-elements';
import UpdateCard from '../SettingsPage/UpdateCard'
import { browserHistory } from 'react-router';
import { getAddedCard } from '../SettingsPage/action'
import { Link } from 'react-router';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import { InfluenceMobile, LogoInfluenceDark } from '../../img';
import { BellIcon } from '../../img';
import { quotaExhausted } from '../../utilities/quotaExhausted';

const NewHeader = (props) =>{

	const {user, profile, logout, 
			renderHelp, openProfile, loading, 
			username, breadcrumb, setBreadCrumbs,agencylogo
		} = props

	const classes = useStyles()

	const [openMenu, setOpenMenu] = useState(false)
	const [openMenuDev, setOpenMenuDev] = useState(true)
	const [dialogStatus, setDialogStatus] = useState(true)
	const [addedCard, setAddedCard] = useState({})
	const [updateCardStatus, setUpdateCardStatus] = useState(false)

	useEffect(() =>{
		handleCloseUpdateDialog()
	},[])
	
    

	const removeItems = (index, fn, func) => {
		if(func) {
			fn.setActiveState(1, true);
			fn.clearNotification();
		}
		let breadcrumbs = breadcrumb;
		breadcrumbs.splice(index+1);
		setBreadCrumbs(breadcrumbs, true);
	};
			
	const handleClose = () => {
		setDialogStatus(false);
	}
		
	const closeHandler = () => {
		setDialogStatus(false);
	}

	const renderBreadCrums = () => {
		let location = window.location.href
		if(location.length > 50  && location.includes('/campaigns/')){
			return(
				<Fragment>
					<Link style={{color: '#183247'}} href={'/campaigns'}>
						{'Campaign'}
					</Link>
					<Link style={{margin: '0 8px', color: 'rgba(0, 0, 0, 0.54)', fontSize: '1rem'}}>
						›
					</Link>
					<Link style={{color: '#183247'}}>
						{'Campaign Settings'}
					</Link>
				</Fragment>
			)
		}else if(location.length > 50  && location.includes('/Analytics/')){
			return(
				<Fragment>
					<Link style={{color: '#183247'}} href={'/campaigns'}>
						{'Campaign'}
					</Link>
					<Link style={{margin: '0 8px', color: 'rgba(0, 0, 0, 0.54)', fontSize: '1rem'}}>
						›
					</Link>
					<Link style={{color: '#183247'}}>
						{'Campaign Summary'}
					</Link>
				</Fragment>
			)
		} else{
			return breadcrumb.map((crumb, index) =>
				<Link style={{color: '#183247'}} href={crumb.path?crumb.path:''} key={crumb.name+index} onClick={() => removeItems(index, crumb.function, crumb.function?true:false)} >
					{crumb.name}
				</Link>
			);
		}
		
	};

	const fetchCard = () =>{
        getAddedCard()
            .then(res=>{
                //setIsCardAdded(res.err)
                setAddedCard(res)
            })
    }
	const handleOpenMenu = () =>{
		setOpenMenu(!openMenu)
		// setOpenMenu((prev)=>console.log('prev', prev))
	}

	const handleCloseMenu=() =>{
		setOpenMenu(false)
	}

	const handleCloseUpdateDialog = () =>{

		if(user.status  === 'cancel'){
			setUpdateCardStatus(true)
		}
		else{
			setUpdateCardStatus(false)
		}
		
	}


	
	return(
		<Box className={classes.mainHeader}>

			{/* -----Upgrade strip---- */}
			<Box className={classes.upgradeStripContainer} style={quotaExhausted(profile) && window.location.pathname!=="/upgrade-plan"?{}:{display:'none'}}>
				<Typography>Your account limit has reached. Click here to upgrade.</Typography>
				<Button component={RouterLink} to={'/upgrade-plan'}>Upgrade Plan</Button>
			</Box>

			{
				// (profile.uniqueVisitorsQoutaLeft < 0  && (profile.plan.name === 'Free Forever Plan' || profile.plan.id === 'price_HJBaYjGF19qCRO')) &&
					<UpgradeModal
						open={quotaExhausted(profile)}
						handleClose={handleClose}
						closeHandler={closeHandler}
						profile = {profile}
						
					/>
			}
				

			<Box className={classes.headerContainer}>
				<Box style={{display:'flex', alignItems:'center'}}>
					{
						agencylogo?
							<Link to='/' className={classes.logoLink}>
									<img src={agencylogo && agencylogo.logo?agencylogo.logo:InfluenceMobile} className={classes.logoImage} alt='' height="60px" width="55px"/>
							</Link>
							:
							<Link to={user && user.role && (user.role.name =='campaign' || user.role.name =='campaignB')?'/':user.path} className={classes.logoLink}>
									<img src={LogoInfluenceDark} className={classes.logoImage} alt={user.logoText?user.logoText:'influence-img'} height="60px" width="55px"/>
							</Link>
					}
					<Box>
						<Breadcrumbs style={{paddingLeft:'20px'}} classes={{ol:classes.ol}} separator="›" aria-label="breadcrumb">
							{renderBreadCrums()}
						</Breadcrumbs>
					</Box>
				</Box>

				<ConnectionStatus/>
				<Box style={{display:'flex', alignItems:'center'}}>
					{
						// checkWhitelable() || profile.hasOwnProperty("masterBrandUrl") ?
						// 	<></>:
						// 	<RouterLink to="/settings" style={{marginRight:'1rem'}}>
						// 		<SettingsOutlinedIcon  className={classes.settingsIconStyle} />
						// 	</RouterLink>
					}
				
					<Box style={{marginRight:'30px'}}>
						{/* <img src={BellIcon} className={"feedcast-trigger"} style={{width:'25px', height:'25px', color:'green', cursor:'pointer'}}/> */}
						<BellIcon className={"feedcast-trigger"} style={{width:'25px', height:'25px', color:'green', cursor:'pointer'}}/>
					</Box>
					<ClickAwayListener onClickAway={handleCloseMenu}>
						<Box className={openMenu ? classes.rightSideActive : classes.rightSide} onClick={handleOpenMenu}>
							<div style={{padding: '0px'}} className={classes.titleLetter}>
								{
									profile.image ?
									<img className={classes.titleImage} src={profile.image}></img>:
									<span>
										{username ? username.charAt(0).toUpperCase():'?'}
									</span>
								}
								{/*username ? username.charAt(0).toUpperCase() + username.slice(1): 'Anonymous'*/}
							</div>
							<Box className={openMenu ? classes.menuStyle : classes.hideMenuStyle} onMouseLeave={handleCloseMenu}>
								{
									checkWhitelable() || profile.hasOwnProperty("masterBrandUrl") ?
										null:
										<span className={classes.menuItem} onClick={openProfile}>
											<Typography  component={RouterLink} variant="h5" style={{fontSize:'14px', display:'flex', alignItems:'center'}}  /*to="/profile"*/>
												<PersonIcon style={{marginRight: '5px', fontSize: '1rem'}}/> Your Profile
											</Typography>
										</span>
								}
							
								<span  onClick={logout} className={classes.menuItem}>
									<Typography component={RouterLink} variant="h5" style={{fontSize:'14px', display:'flex', alignItems:'center'}}>
										<PowerSettingsNewIcon style={{marginRight: '5px', fontSize: '1rem'}}/> Logout
									</Typography>
								</span>
							</Box>
						</Box>
					</ClickAwayListener>
				</Box>
				{user.status === 'cancel' && 
				<Elements>
					<UpdateCard fetchCard={fetchCard} addingNewCard={false} addedCard={addedCard} open={updateCardStatus} handleClose={handleCloseUpdateDialog}/>
				</Elements>
				}


			</Box>
		</Box>
	)
}









const useStyles = makeStyles(theme =>
	createStyles({
		mainHeader:{
			zIndex: theme.zIndex.appBar,
		},
		headerContainer:{
			height: '60px',
			width: '100%',
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
			padding: '0 2rem 0 0.5rem',
			position: 'fixed',
			zIndex: theme.zIndex.appBar,
			background: '#fff',
			boxShadow: '0px 1px 1px 0px #e5e5e5',
			left:0,
			paddingLeft:'0'
		},
		rightSide:{
			position: 'relative',
			padding: '5px',
			borderRadius: '5px',
			cursor: 'pointer',
			'&:hover':{
				// backgroundColor: '#f2f2f2',
				cursor: 'pointer',
			}
		},
		rightSideActive:{
			position: 'relative',
			padding: '5px',
			borderRadius: '5px',
			// backgroundColor: '#f2f2f2',
			cursor: 'pointer',
		},
		menuStyle:{
			width: '150px',
			display:'flex',
			flexDirection: 'column',
			backgroundColor: '#fff',
			justifyContent: 'center',
			position: 'absolute',
			transition: '0.2s',
			borderRadius: '2px',
			border: '1px solid #e3eaef',
			boxShadow: '0 3px 12px rgba(0,0,0,0.05)',
			right: '-17px'
		},
		ol:{
			marginBottom: '0 !important'
		},
		hideMenuStyle:{
			display: 'none',
			transition: '0.2s'
		},
		menuItem:{
			padding: '12px',
			cursor: 'pointer',
			color: '#000',
			fontSize: '14px',
			'&:hover':{
				backgroundColor: '#f9f9f9'
			}
		},
		titleLetter:{
			backgroundColor: '#fba62d',
			fontSize: '13px',
			width: '40px',
			height: '40px',
			borderRadius: '50%',
			textAlign: 'center',
			padding: '0',
			color: '#fff',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		titleImage:{
			width: '40px',
			height: '40px',
			borderRadius: '50%',
			textAlign: 'center',
			color: '#fff',
			// marginRight: '7px'
		},
		settingsIconStyle:{
			fontSize:'40px',
			color:'gray',
			cursor:'pointer',
			padding:'8px',
			borderRadius:'50px',
			'&:hover':{
				backgroundColor:'#f7f8fb'
			}
		},
		logoImage:{
			marginTop:'2px', 
			borderRadius:'2px',
			width:'33px',
			height:'45px'
		},
		logoLink:{
			width:'55px',
			height:'60px',
			display:'flex',
			alignItems: 'center',
			justifyContent:'center'
		},
		upgradeStripContainer:{
			height: theme.custom.upgradeStrip.height,
			backgroundColor: '#0077ff',
			marginLeft: `-${theme.custom.sideBar.width + 5}px`,
			textAlign:'center',
			color:'#fff',
			display:'flex',
			alignItems:'center',
			justifyContent:'center',
			'&>p':{
				margin: '0', 
				textAlign: 'center', 
				fontSize: '14px', 
				backgroundColor: '#07f ', 
				color: '#fff', 
				padding: '11px', 
				fontWeight: '400'
			},
			'&> a':{
				padding: '5px', 
				backgroundColor: '#00d200', 
				color: '#fff', 
				borderRadius: '3px', 
				marginLeft: '5px'
			}
		}
	})
)

export default NewHeader
